import { Moment } from 'moment';
import { HdPlanetKey } from '../../chart/bodygraph/planet-grid/hd-planet-display-config';
import {
  HdTransitGateTransition,
  HdTransitLineTransition,
  HdTransitNowNextPlanet,
  HdTransitStation,
} from '../transit.models';

/**
 * Uniforme invoer van de transit-info-card: de huidige stand van één planeet
 * met de omliggende lijn- en poort-overgangen — dezelfde vorm als
 * `HdTransitNowNextPlanet` (Nu & Straks card view), aangevuld met een
 * optionele segment-range (shift-popup vanuit de lanes) en de stations erin.
 * Alle Momenten zijn UTC.
 */
export interface HdTransitInfoCardData {
  readonly planetKey: HdPlanetKey;
  readonly retrograde: boolean;
  /** Het lijn-segment waarin de planeet staat (`line` = null bij poort-granulariteit). */
  readonly current: { readonly gate: number; readonly line: number | null; readonly sinceUtc: Moment };
  /** Huidige poort met échte start; `null` als de bron die niet kent. */
  readonly currentGate: { readonly gate: number; readonly sinceUtc: Moment } | null;
  readonly prevLine: HdTransitLineTransition | null;
  readonly nextLine: HdTransitLineTransition | null;
  readonly prevGate: HdTransitGateTransition | null;
  readonly nextGate: HdTransitGateTransition | null;
  /** Echte grenzen van het aangeklikte segment (popup vanuit de lanes). */
  readonly fromUtc?: Moment | null;
  readonly toUtc?: Moment | null;
  /** Stations binnen de segment-range (de planeet keert er halverwege). */
  readonly stations?: readonly HdTransitStation[];
}

/** Adapter: Nu & Straks-entry → card-data (vereist een gekende planetKey). */
export function nowNextToInfoCardData(planet: HdTransitNowNextPlanet): HdTransitInfoCardData | null {
  if (planet.planetKey == null) return null;
  return {
    planetKey: planet.planetKey,
    retrograde: planet.retrograde,
    current: planet.current,
    currentGate: planet.currentGate,
    prevLine: planet.prevLine,
    nextLine: planet.nextLine,
    prevGate: planet.prevGate,
    nextGate: planet.nextGate,
  };
}
